module.exports = __webpack_public_path__ + "static/media/03venture_n.58546ef9.svg";